"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var Email = function Email(props) {
  return _react["default"].createElement("svg", {
    className: props.className,
    width: "31px",
    height: "30px",
    viewBox: "0 0 31 30",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(1.000000, 1.000000)"
  }, _react["default"].createElement("path", {
    d: "M13.9996,0.0001 C6.2806,0.0001 -0.0004,6.2801 -0.0004,14.0001 C-0.0004,21.7201 6.2806,28.0001 13.9996,28.0001 C21.7196,28.0001 27.9996,21.7201 27.9996,14.0001 C27.9996,6.2801 21.7196,0.0001 13.9996,0.0001 Z",
    fill: "#002272"
  }), _react["default"].createElement("path", {
    className: "hvr-icon-fill",
    d: "M21.8516,10.2461 L21.8516,12.1401 L21.8516,18.5291 C21.8516,19.3551 21.1796,20.0271 20.3536,20.0271 L7.5756,20.0271 C6.7486,20.0271 6.0776,19.3551 6.0776,18.5291 L6.0776,12.1581 L6.0776,10.2641 L6.0776,9.4971 C6.0776,8.6721 6.7486,8.0001 7.5756,8.0001 L20.3536,8.0001 C21.1796,8.0001 21.8516,8.6721 21.8516,9.4971 L21.8516,10.2461 Z",
    fill: "#FFFFFF"
  }), _react["default"].createElement("path", {
    d: "M13.9727,16.6387 C13.5577,16.6387 13.1417,16.4807 12.8257,16.1657 L8.0767,11.4377 L8.0767,12.1587 L8.0767,18.0277 L19.8517,18.0277 L19.8517,12.1397 L19.8517,11.4267 L15.1237,16.1617 C14.8067,16.4797 14.3897,16.6387 13.9727,16.6387",
    fill: "#002272"
  }), _react["default"].createElement("polygon", {
    fill: "#002272",
    points: "18.4502 10 9.4682 10 13.9722 14.485"
  }))));
};

var _default = Email;
exports["default"] = _default;